export default __webpack_public_path__ + "static/media/kellogg.a84b2cf8.svg";